export class LabelConstants {
    public static readonly EffectiveDate: string = 'Effective Date';
    public static readonly RequestedEffectiveDate: string = 'Requested Effective Date';
    public static readonly LatestVersionLink : string ='Latest';
    public static readonly SpecificVersionLink : string ='Specific';
    public static readonly EffectiveVersionLink : string ='Effective';
    public static readonly MyHardCopyDefaultUserLable : string ='assignedUser';
    public static readonly InActiveGroupMessage : string ='The selected User/Assignment Group for field is inactive. If saved, this may result in blocking the process downstream. Do you want to proceed?';
    public static readonly MyAssignedAdmin : string ='My Assigned Admin';
    public static readonly MyDelegations : string ='My Delegations';
    public static readonly DelegatedToMe : string ='Delegated To Me';
    public static readonly MyDocCollabs : string ='My Doc Collabs';
    public static readonly MyQAReviews : string ='My QA Reviews';
    public static readonly MyDocFormattings : string ='My Doc Formattings';
    public static readonly MyDocReviews : string ='My Doc Reviews';
    public static readonly MyDocApprovals : string ='My Doc Approvals';
    public static readonly MyChangeRequests : string ='My Change Requests';
    public static readonly MyPeriodicReviews : string ='My Periodic Reviews';
    public static readonly MyHardcopyActivities : string ='My Hardcopy Activities';
    public static readonly MyQuarantinedDocuments : string = 'My Quarantined Documents';
    public static readonly MyAcknowledgements : string ='My Acknowledgements';
    public static readonly MyAssignedAdminNoteText : string= 'Excluding Obsolete, Archived and Cancelled Phases';
    public static readonly Forbidden_StatusCode : number = 403;
    public static readonly NotFound_StatusCode : number = 404;
    public static readonly MyPendingTrainings : string = 'My Pending Trainings';
    public static readonly MyTrainingPlanReviews: string = 'My Training Plan Reviews';
    public static readonly MyClientSignatures : string ='My Client Signatures';
    
}
